import { useRouterState } from "@tanstack/react-router";
import NProgress from "nprogress";
import { useEffect } from "react";

import "nprogress/nprogress.css";

// Matches the old nextjs-toploader defaults: no spinner, snappy trickle.
NProgress.configure({ showSpinner: false, minimum: 0.08, trickle: true, trickleSpeed: 200 });

/**
 * Top-of-page progress bar driven by TanStack Router's `isLoading` (loader/
 * beforeLoad in-flight for any match). Replaces the old `NextTopLoader`.
 * The `use-top-loader-on-refetch` hook still
 * drives NProgress directly for non-navigation refetches (filter/sort updates
 * that re-run a `useQuery` without a route change).
 */
export function TopLoader({ color = "#ee5b2b" }: { color?: string }) {
  const isLoading = useRouterState({ select: (s) => s.isLoading });

  useEffect(() => {
    if (isLoading) NProgress.start();
    else NProgress.done();
  }, [isLoading]);

  return (
    <style>{`
      #nprogress .bar { background: ${color} !important; height: 3px; }
      #nprogress .peg { box-shadow: 0 0 10px ${color}, 0 0 5px ${color}; }
    `}</style>
  );
}
